export const YCFPrivacyPolicyData = [{
    header: "",
    content: 
            <div>
                <b>Last Updated:</b> May 12, 2026
            </div>
}, {
    header: "",
    content: 
            <div>
                For the <b>YouTube Comment Filter</b>, we respect your privacy and are committed to protecting the information you share with us. This Privacy Policy explains how we collect, use, store, and protect your data when you use our platform.
                <br/>
            </div>
}, {
    header: "Consent",
    content: 
            <div>
                By using the Chrome Extension <b>YouTube Comment Filter</b>, you agree to the collection and use of information in accordance with this Privacy Policy.
            </div>
}, {
    header: "Information We Collect",
    content: 
            <>
                <div>
                    We collect only the minimal data necessary for the proper functioning of our service. The types of data we collect include:
                </div>
                <div className="infoWCdiv">
                    <div>a) Extension Data</div>
                    <ul>
                        <li>The YouTube Comment Filter extension processes and classifies all comment text locally within your browser, and no comment data is ever sent to our servers or any third-party AI.</li>
                        <li>The extension uses Google Login only to identify your account and manage usage limits.</li>
                    </ul>
                </div>
                <div className="infoWCdiv">
                    <div>b) Log Data (Automatically Collected)</div>
                    <div className="logDataDiv1">To improve our service, we collect basic log data when you access the platform, such as:</div>
                    <ul>
                        <li>IP address</li>
                        <li>Browser type and version</li>
                        <li>Device information</li>
                        <li>Date and time of access</li>
                    </ul>
                    <div>This data is used only for analytics and troubleshooting purposes.</div>
                </div>
                <div className="infoWCdiv last">
                    <div>c) Contact Information</div>
                    <div>If you contact us via email or support forms, we may collect your name, email address, and message content to respond to your inquiries.</div>
                </div>
            </>
}, {
    header: "How We Use Your Information",
    content: 
            <>
                <div>We use collected data solely to:</div>
                <ul>
                    <li>Enhance <b>user experience</b> and site functionality.</li>
                    <li>Prevent <b>fraud, abuse, or security risks</b>.</li>
                    <li>Respond to customer support requests.</li>
                    <li>Identify your account and manage usage limits. Your name, email, and profile picture are used solely within the app for this purpose.</li>
                    <li>Manage license limits and secure billing via Lemon Squeezy, which only receives your email and usage count.</li>
                </ul>
                <div>We <b>never sell or rent your personal data</b>.</div>
            </>
}, {
    header: "Data Storage & Security",
    content: 
            <ul>
                <li>We use <b>secure transmission (HTTPS)</b> to protect your data during processing.</li>
                <li>Any personal data (such as user emails sent to us) is received only by the admin and treated with confidentiality.</li>
                <li>Your information may be transferred to, and maintained on, servers located outside of your state or country where data protection laws may differ.</li>
            </ul>
}, {
    header: "Your Rights",
    content: 
            <>
                <div>As a user, you have the right to:</div>
                <ul>
                    <li><b>Contact us</b> anytime to request deletion of any personal information you’ve shared with us, such as emails or messages.</li>
                    <li><b>Contact us</b> for any privacy-related concerns.</li>
                </ul>
                <div>To make a request, please email us at <span className="emailId">support@easyimagetotext.com</span></div>
            </>
}, {
    header: "Changes to This Policy",
    content: 
            <div>
                We may update this Privacy Policy from time to time. Any changes will be reflected on this page with the updated date. Continued use of the service after changes constitutes acceptance of the new terms.
            </div>
}, 
{
    header: "Contact Us",
    content: 
            <div>
                If you have any questions regarding this Privacy Policy, please contact us at:
                📧  <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "",
    content: 
            <div>
                By using <b>YouTube Comment Filter</b>, you agree to this Privacy Policy.
            </div>
}]